import { render } from "./ReviewTestModal.vue?vue&type=template&id=7f4b12e0&scoped=true"
import script from "./ReviewTestModal.vue?vue&type=script&lang=js"
export * from "./ReviewTestModal.vue?vue&type=script&lang=js"

import "./ReviewTestModal.vue?vue&type=style&index=0&id=7f4b12e0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f4b12e0"]])

export default __exports__